import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from "recharts";

const BAR_RADIUS = [4, 4, 0, 0];

export default function Traffic() {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/admin/traffic?date=${date}`).then(({ data }) => setData(data)); }, [date]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
        <h1 className="font-serif text-3xl font-bold text-brand-green">Statistiques de trafic</h1>
        <input type="date" data-testid="traffic-date" value={date} onChange={(e) => setDate(e.target.value)} className="h-11 rounded-lg border border-brand-green/20 px-3" />
      </div>
      <p className="text-sm text-brand-green/50 mb-6">Comptage maison, sans cookie de pistage ni outil tiers — empreinte non réidentifiable renouvelée chaque jour. Robots et aperçus exclus.</p>
      {data && (
        <>
          <div className="grid grid-cols-2 gap-4 mb-6 max-w-md">
            <div className="bg-white rounded-xl border border-brand-green/10 p-4"><div className="text-sm text-brand-green/60">Visiteurs</div><div className="font-serif text-3xl font-bold text-brand-green" data-testid="traffic-visitors">{data.total_visitors}</div></div>
            <div className="bg-white rounded-xl border border-brand-green/10 p-4"><div className="text-sm text-brand-green/60">Pages vues</div><div className="font-serif text-3xl font-bold text-brand-green">{data.total_views}</div></div>
          </div>
          <div className="bg-white rounded-xl border border-brand-green/10 p-5">
            <h2 className="font-serif text-lg font-bold text-brand-green mb-4">Par heure</h2>
            <ResponsiveContainer width="100%" height={280}>
              <BarChart data={data.by_hour}>
                <XAxis dataKey="hour" tickFormatter={(h) => `${h}h`} stroke="#1A3626" />
                <YAxis stroke="#1A3626" allowDecimals={false} />
                <Tooltip />
                <Bar dataKey="views" fill="#D9A05B" radius={BAR_RADIUS} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      )}
    </div>
  );
}
